import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Dialog } from "@blueprintjs/core";

import { useUrlSearch } from "@hooks/useUrlSearch";

import { SetupProjectChooseType } from "@pages/setup/components/SetupProjectChooseType";
import { SetupProjectPanel } from "@pages/setup/components/SetupProjectPanel";

import { SelectOrgDialog } from "./SelectOrgDialog";

export type DialogState = "new-project" | "select-ci" | "select-org";

export const AddProjectsDialogWrapper = styled.div`
  padding: 16px 32px;
`;

export const AddProjectsDialogHeading = styled.div`
  margin: 8px;
`;

export function AddProjectsDialog() {
  const { search } = useUrlSearch();
  const state = search.get("select-ci");
  const history = useHistory();

  return (
    <Dialog
      title={"New project"}
      isOpen={!!state}
      onClose={() => {
        search.delete("select-ci");
        history.push({
          search: search.toString(),
        });
      }}
    >
      {state === "new-project" ? (
        <SetupProjectPanel />
      ) : state === "select-org" ? (
        <SelectOrgDialog />
      ) : state === "select-ci" ? (
        <SetupProjectChooseType />
      ) : null}
    </Dialog>
  );
}
